<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form
    #editFormAdvancedConfig="ngForm"
    (ngSubmit)="startPlanning()"
    class="clr modal-window-content plan-config plan-config--wide"
    name="editForm"
>
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>Design Settings</h4>
        <button (click)="clear()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div class="siklu-mat-dialog-body custom-scroll-bar content-height-80" matDialogContent>
        <winde-validation-alert [(showAlert)]="showFormValidationAlert" [messageObservable]="alertMessageSubject.asObservable()">
        </winde-validation-alert>

        @if (historyService.logicalTopology.layersModeEnabled) {
            <div class="clr">
                <div class="form-group row justify-content-md-center">
                    <h6 class="col-5" for="design_direction">Design direction</h6>
                    <div class="col-5">
                        <select
                            (change)="changeDesignDirection()"
                            [(ngModel)]="designDirection"
                            [disabled]="!historyService.isEditModeEnabled"
                            class="form-control form-control-sm"
                            id="design_direction"
                            name="design_direction"
                        >
                            <option [ngValue]="true">Bottom-up</option>
                            <option [ngValue]="false">Top-down</option>
                        </select>
                    </div>
                </div>
            </div>
        }

        @if (tabsToShow && tabsToShow.length > 0) {
            <winde-tabs-nav
                (tabChanged)="changeTab($event)"
                [activeTab]="currentTab"
                [customClass]="'tabs-nav--doc-tabs mb-4'"
                [tabsList]="tabsToShow"
                [translationPrefix]="'project.advancedPlan'"
            >
            </winde-tabs-nav>
        }

        <div class="clr row">
            @if (layerNames?.length > 1) {
                <div class="col-12">
                    <winde-tabs-nav
                        (tabChanged)="changeLayerTab($event)"
                        [activeTab]="activeLayerTab"
                        [customClass]="'tabs-nav--horizontal'"
                        [tabsList]="layerNames"
                    ></winde-tabs-nav>
                </div>
            }

            <div class="col-12">
                <div class="tab-content">
                    <!-- GENERAL PARAMS TAB-->
                    @if (currentTab === advancedPlanTabs.GENERAL) {
                        <div class="tab-pane active" role="tabpanel">
                            @if (historyService.logicalTopology.designRingsPerLayer[activeLayerTab]) {
                                <section>
                                    <!-- Redundancy-->
                                    <div class="form-group row justify-content-md-center">
                                        <div class="col-10">
                                            <div class="row">
                                                <h6 class="col-6">Redundancy required</h6>
                                                <div class="col-6 redundancy-col">
                                                    <input
                                                        (change)="setRedundancyEnabled(activeLayerTab, $event.target['checked'])"
                                                        [checked]="redundancyEnabled[activeLayerTab]"
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        class="form-control form-control-sm"
                                                        id="redundancy_required"
                                                        name="redundancy_required"
                                                        type="checkbox"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    @if (redundancyEnabled[activeLayerTab]) {
                                        <div class="form-group row justify-content-md-center form-group--redundancy_per_layer">
                                            <div class="col-10">
                                                <div class="row margin-bottom-10">
                                                    <div class="col-3 col-form-label-sm">Redundant links, count</div>
                                                    <div class="col-3">
                                                        <input
                                                            (ngModelChange)="
                                                                calculateRedundancy(
                                                                    activeLayerTab,
                                                                    historyService.logicalTopology.designRingsPerLayer[activeLayerTab]
                                                                        .rsz_th
                                                                )
                                                            "
                                                            [(inputVal)]="
                                                                historyService.logicalTopology.designRingsPerLayer[activeLayerTab].rsz_th
                                                            "
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.designRingsPerLayer[activeLayerTab].rsz_th
                                                            "
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [max]="nodesCountPerLayer[activeLayerTab]"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            min="1"
                                                            name="rsz_th"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-3 col-form-label-sm">Redundant links, %</div>
                                                    <div class="col-3">
                                                        <input
                                                            (ngModelChange)="
                                                                calculateRedundancy(activeLayerTab, redundancyPercent[activeLayerTab], true)
                                                            "
                                                            [(inputVal)]="redundancyPercent[activeLayerTab]"
                                                            [(ngModel)]="redundancyPercent[activeLayerTab]"
                                                            [decimal]="1"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="100"
                                                            min="1"
                                                            name="redundancyPercent"
                                                            step="0.1"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                    <div class="col-6 row">
                                                        <div class="col-5 col-form-label-sm">Weight (0-1)</div>
                                                        <div class="col-6">
                                                            <input
                                                                [(inputVal)]="
                                                                    historyService.logicalTopology.designRingsPerLayer[activeLayerTab]
                                                                        .rsz_weig
                                                                "
                                                                [(ngModel)]="
                                                                    historyService.logicalTopology.designRingsPerLayer[activeLayerTab]
                                                                        .rsz_weig
                                                                "
                                                                [decimal]="2"
                                                                [disabled]="!historyService.isEditModeEnabled"
                                                                [showValidationText]="showFormValidationAlert"
                                                                class="form-control form-control-sm"
                                                                max="1"
                                                                min="0"
                                                                name="rsz_weig"
                                                                step="0.01"
                                                                type="number"
                                                                windeNumberInputValidation
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <!-- Radios per Location-->
                                    <div class="row justify-content-md-center">
                                        <div class="col-10">
                                            <h6>Radios per Location</h6>
                                        </div>
                                    </div>
                                    <div class="form-group row justify-content-md-center form-group--link_per_node_const">
                                        <div class="col-10">
                                            <div class="row margin-bottom-10">
                                                <div class="col-3 col-form-label-sm">Factor</div>
                                                <div class="col-3">
                                                    <input
                                                        [(inputVal)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].lpn_fac
                                                        "
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].lpn_fac
                                                        "
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [showValidationText]="showFormValidationAlert"
                                                        class="form-control form-control-sm"
                                                        min="0"
                                                        name="lpn_fac"
                                                        type="number"
                                                        windeNumberInputValidation
                                                    />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-3 col-form-label-sm">Threshold</div>
                                                <div class="col-3">
                                                    <input
                                                        [(inputVal)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].lpn_th
                                                        "
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].lpn_th
                                                        "
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [showValidationText]="showFormValidationAlert"
                                                        class="form-control form-control-sm"
                                                        max="100"
                                                        min="1"
                                                        name="lpn_th"
                                                        type="number"
                                                        windeNumberInputValidation
                                                    />
                                                </div>
                                                <div class="col-6 row">
                                                    <div class="col-5 col-form-label-sm">Weight (0-1)</div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="
                                                                historyService.logicalTopology.designRingsPerLayer[activeLayerTab].lpn_weig
                                                            "
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.designRingsPerLayer[activeLayerTab].lpn_weig
                                                            "
                                                            [decimal]="2"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="1"
                                                            min="0"
                                                            name="lpn_weig"
                                                            step="0.01"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Hop Count-->
                                    <div class="row justify-content-md-center">
                                        <div class="col-10">
                                            <h6>Hop Count</h6>
                                        </div>
                                    </div>
                                    <div class="form-group row justify-content-md-center form-group--number_of_hops_const">
                                        <div class="col-10 margin-bottom-10">
                                            <div class="row margin-bottom-10">
                                                <div class="col-3 col-form-label-sm">Factor</div>
                                                <div class="col-3">
                                                    <input
                                                        [(inputVal)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].noh_fac
                                                        "
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].noh_fac
                                                        "
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [showValidationText]="showFormValidationAlert"
                                                        class="form-control form-control-sm"
                                                        min="0"
                                                        name="noh_fac"
                                                        type="number"
                                                        windeNumberInputValidation
                                                    />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-3 col-form-label-sm">Threshold</div>
                                                <div class="col-3">
                                                    <input
                                                        [(inputVal)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].noh_th
                                                        "
                                                        [(ngModel)]="
                                                            historyService.logicalTopology.designRingsPerLayer[activeLayerTab].noh_th
                                                        "
                                                        [disabled]="!historyService.isEditModeEnabled"
                                                        [showValidationText]="showFormValidationAlert"
                                                        class="form-control form-control-sm"
                                                        max="{{ totalNumberOfNodes }}"
                                                        min="0"
                                                        name="noh_th"
                                                        type="number"
                                                        windeNumberInputValidation
                                                    />
                                                </div>
                                                <div class="col-6 row">
                                                    <div class="col-5 col-form-label-sm">Weight (0-1)</div>
                                                    <div class="col-6">
                                                        <input
                                                            [(inputVal)]="
                                                                historyService.logicalTopology.designRingsPerLayer[activeLayerTab].noh_weig
                                                            "
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.designRingsPerLayer[activeLayerTab].noh_weig
                                                            "
                                                            [decimal]="2"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [showValidationText]="showFormValidationAlert"
                                                            class="form-control form-control-sm"
                                                            max="1"
                                                            min="0"
                                                            name="noh_weig"
                                                            step="0.01"
                                                            type="number"
                                                            windeNumberInputValidation
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm" for="opn_weig">Optional locations constraint</span>
                                        <div class="col-5">
                                            <input
                                                [(inputVal)]="historyService.logicalTopology.designRingsPerLayer[activeLayerTab].opn_weig"
                                                [(ngModel)]="historyService.logicalTopology.designRingsPerLayer[activeLayerTab].opn_weig"
                                                [decimal]="2"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                [showValidationText]="showFormValidationAlert"
                                                class="form-control form-control-sm"
                                                id="opn_weig"
                                                max="1"
                                                min="0"
                                                name="opn_weig"
                                                step="0.01"
                                                type="number"
                                                windeNumberInputValidation
                                            />
                                        </div>
                                    </div>
                                </section>
                            }
                            @if (historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab]) {
                                <section>
                                    <!-- Interference Analysis-->
                                    <div class="row justify-content-md-center form-group--analysis_value">
                                        <div class="col-10">
                                            <div class="row margin-bottom-10">
                                                <h6 class="col-6">Interference Analysis</h6>
                                                <div class="col-6">
                                                    <span class="d-block">
                                                        <input
                                                            (ngModelChange)="onWorstCaseChange(activeLayerTab, $event)"
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab]
                                                                    .wc_analysis
                                                            "
                                                            [attr.data-value]="false"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [value]="false"
                                                            class="form-control inp-inline form-group--analysis_value--nominal-analysis analysis_value"
                                                            name="analysis_value_nominal"
                                                            type="radio"
                                                        />
                                                        Optimal
                                                    </span>
                                                    <span class="d-block">
                                                        <input
                                                            (ngModelChange)="onWorstCaseChange(activeLayerTab, $event)"
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab]
                                                                    .wc_analysis
                                                            "
                                                            [attr.data-value]="true"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [value]="true"
                                                            class="form-control inp-inline form-group--analysis_value--worst-case-analysis analysis_value"
                                                            name="analysis_value_worst-case"
                                                            type="radio"
                                                        />
                                                        Worst Case
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Radio position variance-->
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm" for="link_position">Radio position variance</span>
                                        <div class="col-5">
                                            <input
                                                [(inputVal)]="
                                                    historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab].pos_accuracy
                                                "
                                                [(ngModel)]="
                                                    historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab].pos_accuracy
                                                "
                                                [disabled]="
                                                    !historyService.isEditModeEnabled ||
                                                    !historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab].wc_analysis
                                                "
                                                [showValidationText]="showFormValidationAlert"
                                                class="form-control form-control-sm"
                                                id="link_position"
                                                min="0"
                                                name="link_position"
                                                type="number"
                                                windeNumberInputValidation
                                            />
                                        </div>
                                    </div>
                                    <!-- Polarization or Frequency-->
                                    <div class="form-group row justify-content-md-center form-group--polarization_value">
                                        <div class="col-10">
                                            <div class="row margin-bottom-10">
                                                <h6 class="col-6">Polarization or Frequency</h6>
                                                <div class="col-6 form-group--use_min">
                                                    <span class="d-block">
                                                        <input
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab]
                                                                    .pol_priority
                                                            "
                                                            [attr.data-value]="true"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [value]="true"
                                                            class="form-control inp-inline form-group--use_min--polarizations use_min"
                                                            name="use_min--polarizations"
                                                            type="radio"
                                                        />
                                                        Polarizations
                                                    </span>
                                                    <span class="d-block">
                                                        <input
                                                            [(ngModel)]="
                                                                historyService.logicalTopology.autoSetFrequenciesPerLayer[activeLayerTab]
                                                                    .pol_priority
                                                            "
                                                            [attr.data-value]="false"
                                                            [disabled]="!historyService.isEditModeEnabled"
                                                            [value]="false"
                                                            class="form-control inp-inline form-group--use_min--frequencies use_min"
                                                            name="use_min--frequencies"
                                                            type="radio"
                                                        />
                                                        Frequencies
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            }
                        </div>
                    }

                    <!-- PtMP PARAMS TAB-->
                    @if (historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab] && currentTab === advancedPlanTabs.P2MP) {
                        <div class="tab-pane active" role="tabpanel">
                            @if (editForm) {
                                <!-- Resiliency-->
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm"> Resiliency </span>
                                    <div class="col-5 resiliency-col">
                                        <input
                                            (change)="onResiliencyEnabledChange($event.target['checked'], activeLayerTab)"
                                            [checked]="resiliencyEnabled[activeLayerTab]"
                                            [disabled]="!historyService.isEditModeEnabled || !layerContainsMhTgBu[activeLayerTab]"
                                            class="form-control form-control-sm"
                                            id="resiliency_enabled"
                                            name="resiliency_enabled"
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                                <!--  Max PtMP devices per location -->
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm"> Max PtMP devices per location </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="maxDevNumPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                <!--  PoP Distance Factor -->
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-offset-2 col-form-label-sm">
                                        Hop Count Factor
                                        <small class="form-text text-muted"
                                            >Range {{ popDistFacPerLayer[activeLayerTab].min }} ..{{
                                                popDistFacPerLayer[activeLayerTab].max
                                            }}
                                        </small>
                                    </span>
                                    <div class="col-5">
                                        <winde-reactive-input
                                            [form]="editForm"
                                            [input]="popDistFacPerLayer[activeLayerTab]"
                                        ></winde-reactive-input>
                                    </div>
                                </div>
                                <!--  Sector assign mode -->
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm"> Sector assign mode </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="asMethodPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div [hidden]="true" class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm"> P2P distance factor </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="p2pDistFacPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                            }
                            <!--  Device number factor -->
                            @if (!layerContainsMhTgBu[activeLayerTab]) {
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm" for="num_dev_fac">
                                        Device number factor
                                        <small class="form-text text-muted">Range 1..2</small>
                                    </span>
                                    <div class="col-5">
                                        <input
                                            [(inputVal)]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].num_dev_fac"
                                            [(ngModel)]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].num_dev_fac"
                                            [decimal]="2"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            [showValidationText]="showFormValidationAlert"
                                            class="form-control form-control-sm"
                                            id="num_dev_fac"
                                            max="2"
                                            min="1"
                                            name="num_dev_fac"
                                            step="0.01"
                                            type="number"
                                            windeNumberInputValidation
                                        />
                                    </div>
                                </div>
                            }
                            <!--  Uniqueness factor -->
                            @if (!layerContainsMhTgBu[activeLayerTab]) {
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm" for="rand_fac">
                                        Uniqueness factor
                                        <small class="form-text text-muted">Range 3..10</small>
                                    </span>
                                    <div class="col-5">
                                        <input
                                            [(inputVal)]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rand_fac"
                                            [(ngModel)]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rand_fac"
                                            [decimal]="2"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            [showValidationText]="showFormValidationAlert"
                                            class="form-control form-control-sm"
                                            id="rand_fac"
                                            max="10"
                                            min="1"
                                            name="rand_fac"
                                            step="0.01"
                                            type="number"
                                            windeNumberInputValidation
                                        />
                                    </div>
                                </div>
                            }
                            <!--  Prefer forced BU -->
                            @if (!layerContainsMhTgBu[activeLayerTab]) {
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm" for="pref_forced_by_p2mp"> Prefer forced BU </span>
                                    <div class="col-5">
                                        <input
                                            (change)="
                                                historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].pref_forced =
                                                    !historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].pref_forced
                                            "
                                            [checked]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].pref_forced"
                                            [disabled]="!historyService.isEditModeEnabled"
                                            class="form-control form-control-sm"
                                            id="pref_forced_by_p2mp"
                                            name="feed_sector_by_p2mp"
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                            }
                            <!--  Optional BS factor -->
                            @if (editForm && !layerContainsMhTgBu[activeLayerTab]) {
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm">
                                        Optional BU factor
                                        <small class="form-text text-muted"
                                            >Range {{ optBsFacPerLayer[activeLayerTab].min }} ..{{
                                                optBsFacPerLayer[activeLayerTab].max
                                            }}</small
                                        >
                                    </span>
                                    <div class="col-5">
                                        <winde-reactive-input
                                            [form]="editForm"
                                            [input]="optBsFacPerLayer[activeLayerTab]"
                                        ></winde-reactive-input>
                                    </div>
                                </div>
                            }
                            @if (!layerContainsMhTgBu[activeLayerTab]) {
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm" for="rev_feed_fac"> Allow reverse feed </span>
                                    <div class="col-1">
                                        <input
                                            (change)="
                                                historyService.logicalTopology.autodesignP2mpPerLayer[
                                                    activeLayerTab
                                                ].triggerReverseFeedCheck()
                                            "
                                            [checked]="
                                                historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rev_feed_fac === -1
                                            "
                                            [disabled]="!historyService.isEditModeEnabled"
                                            class="form-control form-control-sm"
                                            id="rev_feed_fac_check"
                                            name="feed_sector_by_p2mp"
                                            type="checkbox"
                                        />
                                    </div>
                                    <div class="col-4">
                                        @if (historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rev_feed_fac !== -1) {
                                            <input
                                                [(inputVal)]="
                                                    historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rev_feed_fac
                                                "
                                                [(ngModel)]="
                                                    historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rev_feed_fac
                                                "
                                                [decimal]="2"
                                                [disabled]="!historyService.isEditModeEnabled"
                                                [showValidationText]="showFormValidationAlert"
                                                class="form-control form-control-sm"
                                                id="rev_feed_fac"
                                                max="10"
                                                min="1"
                                                name="rev_feed_fac"
                                                step="0.01"
                                                type="number"
                                                windeNumberInputValidation
                                            />
                                        }
                                        @if (historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].rev_feed_fac !== -1) {
                                            <small class="form-text text-muted">No reverse feed factor, range 1..10</small>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="form-group row justify-content-md-center">
                                <span class="col-5 col-form-label-sm" for="rev_feed_fac"> Global "BU must" devices azimuth </span>
                                <div class="col-5">
                                    <input
                                        [(inputVal)]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].buDeviceAzimuth"
                                        [(ngModel)]="historyService.logicalTopology.autodesignP2mpPerLayer[activeLayerTab].buDeviceAzimuth"
                                        [disabled]="!historyService.isEditModeEnabled"
                                        [showValidationText]="showFormValidationAlert"
                                        class="form-control form-control-sm"
                                        id="bu_device_azimuth"
                                        max="359"
                                        min="0"
                                        name="bu_device_azimuth"
                                        step="1"
                                        type="number"
                                        windeNumberInputValidation
                                    />
                                    <small class="form-text text-muted">Range 0..359</small>
                                </div>
                            </div>
                            @if (editForm) {
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm">
                                        Capacity factor
                                        <small class="form-text text-muted"
                                            >Range {{ capFacPerLayer[activeLayerTab].min }} ..{{
                                                capFacPerLayer[activeLayerTab].max
                                            }}</small
                                        >
                                    </span>
                                    <div class="col-5">
                                        <winde-reactive-input
                                            [form]="editForm"
                                            [input]="capFacPerLayer[activeLayerTab]"
                                        ></winde-reactive-input>
                                    </div>
                                </div>
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div [hidden]="true" class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm">
                                            Cost factor
                                            <small class="form-text text-muted"
                                                >Range {{ costFacPerLayer[activeLayerTab].min }} ..{{
                                                    costFacPerLayer[activeLayerTab].max
                                                }}</small
                                            >
                                        </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="costFacPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                <div class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm">
                                        Max azimuth in sector
                                        <small class="form-text text-muted"
                                            >Range {{ lcentDistPerLayer[activeLayerTab].min }}..{{
                                                lcentDistPerLayer[activeLayerTab].max
                                            }}</small
                                        >
                                    </span>
                                    <div class="col-5">
                                        <winde-reactive-input
                                            [form]="editForm"
                                            [input]="lcentDistPerLayer[activeLayerTab]"
                                        ></winde-reactive-input>
                                    </div>
                                </div>
                                <div [hidden]="true" class="form-group row justify-content-md-center">
                                    <span class="col-5 col-form-label-sm">
                                        Take rate
                                        <small class="form-text text-muted"
                                            >Range {{ takeRatePerLayer[activeLayerTab].min }} ..{{
                                                takeRatePerLayer[activeLayerTab].max
                                            }}</small
                                        >
                                    </span>
                                    <div class="col-5">
                                        <winde-reactive-input
                                            [form]="editForm"
                                            [input]="takeRatePerLayer[activeLayerTab]"
                                        ></winde-reactive-input>
                                    </div>
                                </div>
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm"> Limit on boxes </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="limBoxesPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div [hidden]="true" class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm">
                                            N candidate window
                                            <small class="form-text text-muted"
                                                >Range {{ nCandWinPerLayer[activeLayerTab].min }} ..{{
                                                    nCandWinPerLayer[activeLayerTab].max
                                                }}</small
                                            >
                                        </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="nCandWinPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                @if (!layerContainsMhTgBu[activeLayerTab]) {
                                    <div [hidden]="true" class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm">
                                            Max. iterations
                                            <small class="form-text text-muted"
                                                >Range {{ tgMaxIttrPerLayer[activeLayerTab].min }}..{{
                                                    tgMaxIttrPerLayer[activeLayerTab].max
                                                }}</small
                                            >
                                        </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="tgMaxIttrPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                @if (resiliencyEnabled[activeLayerTab]) {
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm">
                                            Connected factor
                                            <small class="form-text text-muted"
                                                >Range {{ peerBsFacPerLayer[activeLayerTab].min }}..{{
                                                    peerBsFacPerLayer[activeLayerTab].max
                                                }}</small
                                            >
                                        </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="peerBsFacPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                @if (resiliencyEnabled[activeLayerTab]) {
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm">
                                            Resiliency factor
                                            <small class="form-text text-muted"
                                                >Range {{ redunFacPerLayer[activeLayerTab].min }} ..{{
                                                    redunFacPerLayer[activeLayerTab].max
                                                }}</small
                                            >
                                        </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="redunFacPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                                @if (resiliencyEnabled[activeLayerTab]) {
                                    <div class="form-group row justify-content-md-center">
                                        <span class="col-5 col-form-label-sm">
                                            Tunnel factor
                                            <small class="form-text text-muted"
                                                >Range {{ tunnelFacPerLayer[activeLayerTab].min }}..{{
                                                    tunnelFacPerLayer[activeLayerTab].max
                                                }}</small
                                            >
                                        </span>
                                        <div class="col-5">
                                            <winde-reactive-input
                                                [form]="editForm"
                                                [input]="tunnelFacPerLayer[activeLayerTab]"
                                            ></winde-reactive-input>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            </div>

            <div class="col-12">
                <div class="row justify-content-md-center align-items-center">
                    @if (historyService.logicalTopology.layersModeEnabled) {
                        <div class="col-5 col-form-label-sm">
                            <button
                                (click)="copyDesignSettingsFromLayer(currentTab)"
                                class="btn btn-link btn-sm btn-copy-layer-settings px-0"
                                id="copy-general-design-btn_{{ activeLayerTab }}"
                            >
                                {{ 'project.manualDesign.copyDesignSettingsFrom' | translate }}
                            </button>
                        </div>
                        <div class="col-5">
                            <select
                                [(ngModel)]="copyDesignSettingsLayer"
                                [disabled]="!historyService.isEditModeEnabled"
                                class="form-control form-control-sm"
                                id="layer_to_copy_general_settings_from_{{ activeLayerTab }}"
                                name="layer_to_copy_general_settings_from_{{ activeLayerTab }}"
                            >
                                @for (layerToCopyFrom of historyService.logicalTopology.layers; track layerToCopyFrom) {
                                    <option [ngValue]="layerToCopyFrom.layerIndex">
                                        {{ layerToCopyFrom.getFullName() }}
                                    </option>
                                }
                            </select>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <div class="form-check mt-0 mr-4 is-multiple-check">
            <input
                [(ngModel)]="projectUserSessionService.isAutoRepeatDesign"
                [disabled]="!historyService.isEditModeEnabled"
                class="form-check-input"
                id="isMultipleDesignModal"
                name="isMultipleDesignModal"
                type="checkbox"
            />
            <span class="form-check-label"> Auto-Repeat Design </span>
        </div>
        <button [disabled]="!historyService.isEditModeEnabled" type="submit" windeGreen>Start Design</button>
    </div>
</form>
